import { css, ElementStyles } from '@microsoft/fast-element';
import { zeroSliderStyles as styles } from '@genesislcap/foundation-zero';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import { boxSizing } from '../../../styles';

export const customSliderStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${styles(context, definition)}
  ${boxSizing}
  :host {
    --design-unit: 8;
    --track-overhang: calc((var(--design-unit)) * -2);

    transition: all 0.25s ease 0s;
    margin: 0;
  }

  :host([orientation='horizontal']) .positioning-region {
    grid-template-rows: calc(var(--thumb-size) * 1px - 24px) 1fr;
    margin: 0 15px;
  }

  .track-progress {
    background: linear-gradient(90deg, var(--purple) 0%, var(--cyan) 100%);
  }

  .thumb-container {
    width: auto;
    min-width: calc(var(--thumb-size) * 1px - 2px);
    height: calc(var(--thumb-size) * 1px - 6px);
    border-radius: 4px;
    border: 1px solid var(--border-1);
    box-shadow: 0 4px 10px rgb(0 0 0 / 25%);
    background: linear-gradient(90deg, var(--purple) 0%, var(--cyan) 100%);
    color: var(--white);
    font-size: 0.625rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.2rem 0.3rem;
  }
`;
